(function () {
  "use strict";

  if (window.__AKAY_VT_LOADER_READY__) return;
  window.__AKAY_VT_LOADER_READY__ = true;

  var loaderScript = document.currentScript;
  if (!loaderScript) return;

  var formJsUrl = loaderScript.getAttribute("data-form-js") || "";
  var formCssUrl = loaderScript.getAttribute("data-form-css") || "";
  var loadingPromise = null;

  function roots() {
    return Array.prototype.slice.call(
      document.querySelectorAll("[data-akay-virtual-try]")
    );
  }

  function ensureCss() {
    if (!formCssUrl) return;
    if (document.querySelector('link[data-akay-vt-css="1"]')) return;

    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = formCssUrl;
    link.setAttribute("data-akay-vt-css", "1");
    document.head.appendChild(link);
  }

  function ensureFormScript() {
    if (
      window.AKAYVirtualTry &&
      typeof window.AKAYVirtualTry.open === "function"
    ) {
      return Promise.resolve();
    }

    if (loadingPromise) return loadingPromise;

    loadingPromise = new Promise(function (resolve, reject) {
      ensureCss();

      var existing = document.querySelector(
        'script[data-akay-vt-form-js="1"]'
      );

      if (existing) {
        existing.addEventListener("load", resolve, { once: true });
        existing.addEventListener(
          "error",
          function () {
            loadingPromise = null;
            reject(new Error("AKAY Virtual Try script could not be loaded."));
          },
          { once: true }
        );
        return;
      }

      if (!formJsUrl) {
        reject(new Error("AKAY Virtual Try form JS URL is missing."));
        return;
      }

      var script = document.createElement("script");
      script.src = formJsUrl;
      script.defer = true;
      script.setAttribute("data-akay-vt-form-js", "1");

      script.onload = resolve;
      script.onerror = function () {
        loadingPromise = null;
        reject(new Error("AKAY Virtual Try script could not be loaded."));
      };

      document.head.appendChild(script);
    });

    return loadingPromise;
  }

  function isAutostart(root) {
    return (
      String(root.getAttribute("data-autostart") || "true").toLowerCase() !==
      "false"
    );
  }

  function openRoot(root, launchButton) {
    if (!root) return;

    if (launchButton) {
      launchButton.setAttribute("aria-busy", "true");
      launchButton.disabled = true;
    }

    ensureFormScript()
      .then(function () {
        if (
          window.AKAYVirtualTry &&
          typeof window.AKAYVirtualTry.open === "function"
        ) {
          return window.AKAYVirtualTry.open(root, {
            scroll: true,
          });
        }
      })
      .catch(function (error) {
        console.error("[AKAY_VT_LOADER]", error);
      })
      .finally(function () {
        if (launchButton) {
          launchButton.removeAttribute("aria-busy");
          launchButton.disabled = false;
        }
      });
  }

  function bindLazyLaunch(root) {
    var launchId = String(
      root.getAttribute("data-launch-button-id") || ""
    ).trim();

    if (!launchId) return;

    var button = document.getElementById(launchId);
    if (!button) return;

    if (button.getAttribute("data-akay-vt-loader-bound") === "1") return;

    button.setAttribute("data-akay-vt-loader-bound", "1");

    button.addEventListener("click", function () {
      openRoot(root, button);
    });
  }

  function boot() {
    var items = roots();
    if (!items.length) return;

    items.forEach(function (root) {
      if (isAutostart(root)) {
        root.hidden = false;
      } else {
        bindLazyLaunch(root);
      }
    });

    if (items.some(isAutostart)) {
      ensureFormScript().catch(function (error) {
        console.error("[AKAY_VT_LOADER]", error);
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
  window.AKAYVirtualTryLoaderRefresh = boot;
})();